module.exports = __webpack_public_path__ + "img/6.73d94c32.png";